import type { TableColumnConfig } from '../../../data/table-column-config';
import { DateTimeCellComponent } from './date-time-cell.component';
import type { TranslateAbleText } from '@pct-ng/i18n';

export function createDateTimeColumn<T>(
  id: string,
  field: keyof T,
  label: TranslateAbleText,
  sortable = false,
): TableColumnConfig<T> {
  return {
    id,
    field,
    label,
    cellContent: DateTimeCellComponent,
    sortable,
  };
}
